module.exports = __webpack_public_path__ + "static/media/morsel.15d8baf3.webp";